// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared";
import { equal } from "@lg/shared";
import * as z from "zod";
import { immerable } from "immer";
import { untracked } from "@angular/core";

const $schemas = new Map<string, z.ZodObject<any>>();
@jsonClass('Toolbox.CompanyNameResolution')
class Toolbox__CompanyNameResolution {
    @jsonProperty(() => Toolbox__CompanyNameResolution.Id)
    id: Toolbox__CompanyNameResolution.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "inputName", "chosenOption", "isRemember", "options", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "inputName", "chosenOption", "isRemember", "options", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "inputName", "chosenOption", "isRemember", "options", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: LowgileDataUtil.unwrapReadonly(Object.freeze({ "inputName": "string", "chosenOption": "This.CompanyNameResolutionOption", "isRemember": "boolean", "options": "Toolbox.CompanyNameResolutionOption[]", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "number" } as const)),
        staticEntityProperties: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToManyRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ options: () => Toolbox.CompanyNameResolutionOption } as const)),
        oneToOneOwningRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: LowgileDataUtil.unwrapReadonly(Object.freeze({ chosenOption: () => Toolbox.CompanyNameResolutionOption } as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θinputName = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θchosenOption = Signals.proxySignalDeferred<This.CompanyNameResolutionOption>(() => (undefined) as any);
    private readonly θisRemember = Signals.proxySignalDeferred<boolean>(() => (false) as any);
    private readonly θoptions = Signals.proxySignalDeferred<Toolbox.CompanyNameResolutionOption[]>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Toolbox.CompanyNameResolution' {
        return 'Toolbox.CompanyNameResolution'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Toolbox.CompanyNameResolution' {
        return 'Toolbox.CompanyNameResolution'
    }

    static get __baseType(): 'Toolbox.CompanyNameResolution' {
        return 'Toolbox.CompanyNameResolution'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Toolbox.CompanyNameResolution' {
        return 'Toolbox.CompanyNameResolution'
    }

    get [BoInfoSymbol]() {
        return Toolbox__CompanyNameResolution[BoInfoSymbol]
    }

    get inputName(): string {
        return this.θinputName?.()
    }

    set inputName(inputName) {
        this.θinputName.set(LowgileDataUtil.coerceDataType(inputName, 'string', false, true))
    }

    get chosenOption(): This.CompanyNameResolutionOption {
        return this.θchosenOption?.()
    }

    set chosenOption(chosenOption) {
        this.θchosenOption.set(LowgileDataUtil.coerceDataType(chosenOption, 'This.CompanyNameResolutionOption', false, true))
    }

    get isRemember(): boolean {
        return this.θisRemember?.()
    }

    set isRemember(isRemember) {
        this.θisRemember.set(LowgileDataUtil.coerceDataType(isRemember, 'boolean', false, true))
    }

    get options(): Toolbox.CompanyNameResolutionOption[] {
        return this.θoptions?.()
    }

    set options(options) {
        this.θoptions.set(LowgileDataUtil.coerceDataType(options, Toolbox.CompanyNameResolutionOption, true, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(LowgileDataUtil.coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(LowgileDataUtil.coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(LowgileDataUtil.coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(LowgileDataUtil.coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(LowgileDataUtil.coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(LowgileDataUtil.coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(LowgileDataUtil.coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Toolbox__CompanyNameResolution>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                options: [],
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => LowgileDataUtil.assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Toolbox__CompanyNameResolution()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Toolbox__CompanyNameResolution>, restrictToClass?: Class<Partial<Toolbox__CompanyNameResolution>>) {
        LowgileDataUtil.assignCommonProperties(this, source, { restrictToClass })
    }

    static $getSchema(): any {

        const key = ""
        if ($schemas.has(key)) return $schemas.get(key)!
        const schema = z.object({
            inputName: z.string(),
            get chosenOption() { return Toolbox.CompanyNameResolutionOption.$getSchema() },
            isRemember: z.boolean(),
            get options() { return z.array(Toolbox.CompanyNameResolutionOption.$getSchema()) },
            createdOn: z.coerce.date(),
            get createdBy() { return System.UserIdAndName.$getSchema() },
            updatedOn: z.coerce.date(),
            get updatedBy() { return System.UserIdAndName.$getSchema() },
            deletedOn: z.coerce.date(),
            get deletedBy() { return System.UserIdAndName.$getSchema() },
            versionNumber: z.number(),
        }
        )
        $schemas.set(key, schema)
        return schema

    }

    $getSchema(): any {
        return Toolbox__CompanyNameResolution.$getSchema()
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('inputName', 'chosenOption', 'isRemember', 'options', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Toolbox__CompanyNameResolution {
        return equal(this, other)
    }
}

namespace Toolbox__CompanyNameResolution { }

export import CompanyNameResolution = Toolbox__CompanyNameResolution
setTimeout(() => {
    jsonProperty(() => String)(Toolbox__CompanyNameResolution.prototype, 'inputName')
    jsonProperty(() => Toolbox.CompanyNameResolutionOption)(Toolbox__CompanyNameResolution.prototype, 'chosenOption')
    jsonProperty(() => Boolean)(Toolbox__CompanyNameResolution.prototype, 'isRemember')
    jsonArrayProperty(() => Toolbox.CompanyNameResolutionOption)(Toolbox__CompanyNameResolution.prototype, 'options')
    jsonProperty(() => Date)(Toolbox__CompanyNameResolution.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__CompanyNameResolution.prototype, 'createdBy')
    jsonProperty(() => Date)(Toolbox__CompanyNameResolution.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__CompanyNameResolution.prototype, 'updatedBy')
    jsonProperty(() => Date)(Toolbox__CompanyNameResolution.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__CompanyNameResolution.prototype, 'deletedBy')
    jsonProperty(() => Number)(Toolbox__CompanyNameResolution.prototype, 'versionNumber')
})

export const CompanyNameResolutionθId = Number;

export type CompanyNameResolutionθId = number;

namespace Toolbox__CompanyNameResolution {
    export type Id = NominalType<number, 'Toolbox.CompanyNameResolution'>

}
